import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import "./Gallery.css";

const GalleryUpload = ({ user }) => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    media_file: null,
    media_type: "image",
  });
  const [loading, setLoading] = useState(false);
  const [preview, setPreview] = useState(null);
  const [dragOver, setDragOver] = useState(false);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    processFile(file);
  };

  const processFile = (file) => {
    if (file) {
      setFormData((prev) => ({
        ...prev,
        media_file: file,
      }));

      if (file.type.startsWith("image/")) {
        const reader = new FileReader();
        reader.onload = (e) => setPreview(e.target.result);
        reader.readAsDataURL(file);
        setFormData((prev) => ({ ...prev, media_type: "image" }));
      } else if (file.type.startsWith("video/")) {
        setPreview(URL.createObjectURL(file));
        setFormData((prev) => ({ ...prev, media_type: "video" }));
      }
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragOver(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setDragOver(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragOver(false);
    const file = e.dataTransfer.files[0];
    if (file) {
      processFile(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.media_file) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Please select a media file",
      });
      return;
    }

    setLoading(true);

    try {
      const token = localStorage.getItem("access");
      const submitData = new FormData();
      submitData.append("media_files", formData.media_file);
      submitData.append("media_type", formData.media_type);

      await axios.post(
        "https://ambatturindustrialestate.com/api/api/gallery-media/upload/",
        submitData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Media uploaded successfully",
      });

      navigate("/gallery");
    } catch (error) {
      console.error("Error uploading media:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to upload media",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="gallery-container">
      <div className="gallery-content">
        <div className="gallery-form-container gallery-fade-in">
          <h1 className="gallery-form-title">Upload Media</h1>

          <form onSubmit={handleSubmit} className="gallery-form">
            <div className="gallery-form-group">
              <label className="gallery-form-label">Media File</label>
              <div
                className={`gallery-upload-area ${dragOver ? "drag-over" : ""}`}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
                onClick={() => document.getElementById("media_file").click()}
              >
                <div className="text-center">
                  {preview ? (
                    <div className="gallery-preview">
                      {formData.media_type === "image" ? (
                        <img
                          src={preview}
                          alt="Preview"
                          className="gallery-preview-media"
                        />
                      ) : (
                        <video
                          src={preview}
                          className="gallery-preview-media"
                          controls
                        />
                      )}
                    </div>
                  ) : (
                    <>
                      <div className="gallery-empty-icon">📁</div>
                      <p className="gallery-empty-text">
                        Click to upload or drag and drop
                      </p>
                      <p className="text-xs text-gray-500 mt-2">
                        PNG, JPG, GIF, MP4, MOV up to 10MB
                      </p>
                    </>
                  )}
                </div>
                <input
                  id="media_file"
                  name="media_file"
                  type="file"
                  className="sr-only"
                  onChange={handleFileChange}
                  accept="image/*,video/*"
                />
              </div>
            </div>

            <div className="gallery-form-group">
              <label className="gallery-form-label">Media Type</label>
              <select
                value={formData.media_type}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    media_type: e.target.value,
                  }))
                }
                className="gallery-form-select"
              >
                <option value="image">Image</option>
                <option value="video">Video</option>
              </select>
            </div>

            <div className="gallery-btn-group">
              <button
                type="button"
                onClick={() => navigate("/gallery")}
                className="gallery-btn gallery-btn-secondary"
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={loading}
                className="gallery-btn gallery-btn-primary"
              >
                {loading ? (
                  <>
                    <div
                      className="gallery-spinner"
                      style={{
                        width: "16px",
                        height: "16px",
                        borderWidth: "2px",
                      }}
                    ></div>
                    Uploading...
                  </>
                ) : (
                  "Upload Media"
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default GalleryUpload;
